<template>
  <v-btn
    :dark="dark"
    :[size]="true"
    :fab="fab"
    color="info"
    :to="$route.path + '/add'"
  >
    <v-icon :[size]="true" :dark="dark"> mdi-plus </v-icon>
    <span v-if="!fab"> Add</span>
  </v-btn>
</template>

<script lang="ts">
import Vue from "vue";
import VueTypes from "vue-types";

export default Vue.extend({
  name: "AddBtn",

  data() {
    return {};
  },
  props: {
    size: VueTypes.string.def("small"),
    fab: VueTypes.bool.def(false),
    dark: VueTypes.bool.def(false),
  },
});
</script>
